import React from 'react';
import { useTheme } from 'styled-components';

import { IOcAppTheme } from '../OcWidget/config/ocTheme';
import { StyledSkeletonSVG } from './AiChatSkeleton.styled';

const AiChatSkeleton: React.FC = () => {
  const theme = useTheme() as IOcAppTheme;
  
  const lightColor = theme.color.loadingBackgroundGradientLight;
  const darkColor = theme.color.loadingBackgroundGradientDark;
  
  return (
    <StyledSkeletonSVG
      preserveAspectRatio="none"
      className="rounded"
      style={{ width: '100%', height: '344px' }}
    >
      <defs>
        <linearGradient id="skeleton-svg-gradient" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0%" stopColor={lightColor}>
            <animate
              attributeName="stop-color"
              values={`${lightColor}; ${darkColor}; ${lightColor};`}
              dur="3s"
              repeatCount="indefinite"
            />
          </stop>
          <stop offset="100%" stopColor={darkColor}>
            <animate
              attributeName="stop-color"
              values={`${darkColor}; ${lightColor}; ${darkColor};`}
              dur="3s"
              repeatCount="indefinite"
            />
          </stop>
        </linearGradient>
      </defs>
      <rect x={0} y={0} width="100%" height="100%" />
    </StyledSkeletonSVG>
  );
};

export default AiChatSkeleton;
